<script lang="ts" setup>
import { computed } from 'vue'

import RehabilitationAct from '@/stay-displayer/smr/rhs/rehabilitation-act/RehabilitationAct.vue'
import { CodedRehabilitationAct, RhsDashboardTitle, RhsDashboardType } from '@/store/modules/stay/smr/types'

const props = defineProps<{
  codedRehabilitationActs: CodedRehabilitationAct[]
}>()

const displayedCodedRehabilitationActs = computed(() =>
  props.codedRehabilitationActs.filter((codedRehabilitationAct) => !codedRehabilitationAct.disabled),
)
</script>

<template>
  <div class="dashboard-title d-flex justify-content-between">
    <small>{{ RhsDashboardTitle[RhsDashboardType.RHS_DASHBOARD_ACT_CSARR] }}</small>
    <small>{{ $t('stayDisplayer.smr.rhs.codingInProgress') }}</small>
  </div>
  <div
    v-if="displayedCodedRehabilitationActs.length === 0"
    class="no-rehabilitation-acts"
  >
    <small class="aligned-row fst-italic">Aucun acte</small>
  </div>
  <rehabilitation-act
    v-for="codedRehabilitationAct in displayedCodedRehabilitationActs"
    v-else
    :key="codedRehabilitationAct.id"
    :coded-rehabilitation-act="codedRehabilitationAct"
  />
</template>
